export default __webpack_public_path__ + "static/media/SMK2.295752d7.png";